module.exports = __webpack_public_path__ + "media/images/amex-c8b393abaa5de9d28595735a0e94966e.png";